// extracted by mini-css-extract-plugin
module.exports = {"map":"TextInput_map__a1M_6","wrapper":"TextInput_wrapper__18Onc","frame-input":"TextInput_frame-input__3_jgq"};